import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getTaskInfo } from "../../redux/new-dashboard/dashboardSlice";

function UseFetchTaskInfo() {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userData?.email) {
      dispatch(
        getTaskInfo(userData?.["custom:custom_username"], userData?.email),
      );
    }
  }, [userData?.email]);
  return null;
}

export default UseFetchTaskInfo;
